import PromoCodes from './PromoCodes.view';

export default PromoCodes;
